import { useMemo } from 'react'
import styled from 'styled-components/macro'
import { COLORS } from '../GlobalStyles'
import { ImageLoader } from './ImageLoader'
import mockups from '../assets/creator/creator-mockups2.png'

const formatDuration = (startDate, endDate = new Date()) => {
  const totalMonths =
    endDate.getFullYear() * 12 +
    endDate.getMonth() -
    (startDate.getFullYear() * 12 + startDate.getMonth())
  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12
  return [
    years > 0 ? `${years} yr${years > 1 ? 's' : ''}` : null,
    months > 0 ? `${months} mo${months > 1 ? 's' : ''}` : null,
  ]
    .filter(Boolean)
    .join(' ')
}

export const Employment = () => {
  // Start date: June 1, 2021
  const creatorDuration = useMemo(
    () => formatDuration(new Date(2021, 5, 1)),
    []
  )

  return (
    <Wrapper>
      <div className='section-inner experience'>
        <h2 className='heading'>
          [ <b>experience</b> ]
        </h2>

        {/* Creator.co Role */}
        <h3>Creator</h3>
        <p className='title'>Full Stack Developer & Lead UX/UI Engineer</p>
        <p className='date'>
          Jun 2021 – Present • {creatorDuration}
        </p>
        <div className='text'>
          <p>
            I&apos;m building and maintaining Creator.co&apos;s React monorepo dashboards (Brand, Creator,
            Admin), designing new UX/UI flows, and adding features end-to-end—from frontend
            Storybook components through Express/Node APIs to PostgreSQL via Prisma and AWS
            infrastructure.
          </p>
          <div className='mockups'>
            <ImageLoader src={mockups} alt='Creator.co dashboards' borderRadius='10px' />
          </div>
          <ul>
            <li>
              <b>Feature ownership:</b> Collaboration Hub, Campaign builder, Outreach workflows, Phyllo social platform API integration, Social-listening feed, Analytics
            </li>
            <li>
              <b>Backend & DevOps:</b> Optimized Node server endpoints, AWS Lambda functions, RDS queries, and GitHub Actions CI/CD
            </li>
            <li>
              <b>Quality & Collaboration:</b> Debugging, E2E & unit testing, Storybook, ESLint/Prettier linting, peer code reviews and mentoring
            </li>
            <li>
              <b>Tech stack:</b> JavaScript, TypeScript, React, Styled Components, Express, Node, Prisma, PostgreSQL, AWS, Docker, GitHub Actions
            </li>
          </ul>
        </div>

        {/* Freelance Role */}
        <h3 style={{ marginTop: '60px' }}>Self-Employed</h3>
        <p className='title'>Freelance Web Developer</p>
        <p className='date'>Apr - Jun 2021 • 3 mos</p>
        <div className='text'>
          <p>
            Built pages from Figma mocks, wired up data-driven components, ensured responsive layouts, added file-uploads and HTML emails, and squashed bugs for various small business clients.
          </p>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background: #fff;
  .heading {
    color: ${COLORS.dark};
  }
  .mockups {
    width: 100%;
    margin: 40px 0;
  }
  .date {
    color: ${COLORS.primaryAccent};
    margin-bottom: 10px;
  }
  .text p {
    margin: 10px 0;
    line-height: 1.5;
  }
  .text ul {
    margin: 10px 0 20px 20px;
    list-style: disc;
    color: #444;
  }
`
